module.exports = __webpack_public_path__ + "img/145.f0ce4f42.jpg";